<template>
    <div class="elder">
        <mt-header fixed title="老人信息编辑">
            <router-link to="/community" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-info">
            <div class="elder-info-block" @click="enterEdit('basic')">
                <div class="elder-block-icon">
                    <img src="../../static/staff.png" />
                </div>
                <div class="elder-block-title">基本信息修改</div>
            </div>

            <div class="elder-info-block" @click="enterEdit('extend')">
                <div class="elder-block-icon">
                    <img src="../../static/profile.png" />
                </div>
                <div class="elder-block-title">延伸信息修改</div>
            </div>

            <div class="elder-info-block" @click="enterEdit('buzhu')">
                <div class="elder-block-icon">
                    <img src="../../static/service.png" />
                </div>
                <div class="elder-block-title">助补信息修改</div>
            </div>

            <div class="elder-info-block" @click="enterEdit('family')">
                <div class="elder-block-icon">
                    <img src="../../static/transfer.png" />
                </div>
                <div class="elder-block-title">家庭信息修改</div>
            </div>

            <div class="elder-info-block" @click="enterEdit('demand')">
                <div class="elder-block-icon">
                    <img src="../../static/vegetables.png" />
                </div>
                <div class="elder-block-title">需求信息修改</div>
            </div>

            <div class="elder-info-block" @click="enterEdit('healthy')">
                <div class="elder-block-icon">
                    <img src="../../static/healthy.png" />
                </div>
                <div class="elder-block-title">健康信息修改</div>
            </div>

            <div class="elder-info-block" @click="enterEdit('transfer')">
                <div class="elder-block-icon">
                    <img src="../../static/elder.png" />
                </div>
                <div class="elder-block-title">老人转出申请</div>
            </div>

            <div class="elder-info-block" @click="signElder('sign')" v-if="!elder_sign">
                <div class="elder-block-icon">
                    <img src="../../static/biaoji.png" />
                </div>
                <div class="elder-block-title">特殊标记老人</div>
            </div>

            <div class="elder-info-block" @click="signElder('cancel')" v-if="elder_sign">
                <div class="elder-block-icon">
                    <img src="../../static/biaoji.png" />
                </div>
                <div class="elder-block-title">取消特殊标记</div>
            </div>
        </div>
    </div>
</template>
<style>

    .elder-info{
        padding:70px 20px 10px 20px;
    }

    .elder-info-block{
        background:#fff;
        display:flex;
        align-items: center;
        padding:20px 50px;
        margin-bottom:15px;
        border-radius: 15px;
    }

    .elder-block-title{
        padding-left:20px;
    }

    .elder-block-icon img{
        width:30px;
    }
</style>
<script>
    import { MessageBox } from 'mint-ui'

    export default{

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,
                elder_sign:false
            }
        },
        methods:{
            enterEdit(type){
               // console.log(type);
                this.$router.push('/elder/'+type+'/'+this.id)
            },

            signElder(type){

                let text = type=='sign'?'确定标记该老人?':'确定取消标记？';

                MessageBox.confirm(text).then(action => {
                    this.$indicator.open('加载中');

                    this.$axios.post("/elder/sign", {openid:this.openid,elder:this.id,type:type})
                        .then(data => {

                            this.$indicator.close();

                            if (data.data.code === 'OK') {
                                this.$toast('处理成功!');
                                this.$router.push('/community')
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                });
            }

        },

        created(){

            this.$axios.get('/elder/sign?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.elder_sign = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });

        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/elder.vue